import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09dca050"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-board dropdown" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, [
  /*#__PURE__*/_createTextVNode("Create new board "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" remaining")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-question-circle position-absolute" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "board" }, "Board title", -1))
const _hoisted_5 = { class: "error text-danger mb-3 mt-1" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Create")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_action_button = _resolveComponent("action-button")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_workspace_dropdown = _resolveComponent("workspace-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_action_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCreateBoardDD = true)),
      "data-bs-toggle": "dropdown",
      class: "d-flex h-100 w-100 justify-content-center align-items-center p-2 position-relative dropdown-toggle"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_workspace_dropdown, {
      title: "Create board",
      show: _ctx.showCreateBoardDD,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showCreateBoardDD = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Form, { onSubmit: _ctx.handleCreateBoard }, {
          default: _withCtx(({ meta: { valid }, errors }) => [
            _hoisted_4,
            _createVNode(_component_Field, {
              type: "text",
              modelValue: _ctx.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
              autofocus: "",
              name: "name",
              rules: "required",
              class: "form-control"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(errors['name']), 1),
            _createVNode(_component_action_button, {
              type: "submit",
              disabled: !valid
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 2
            }, 1032, ["disabled"])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}